/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsMessageExecutionRateFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsMessageExecutionRateFormat = ClosedEnum<
  typeof GetApiV3MetricsMessageExecutionRateFormat
>;

/**
 * Message Type
 */
export const MessageType = {
  Query: "query",
  Update: "update",
  All: "all",
} as const;
/**
 * Message Type
 */
export type MessageType = ClosedEnum<typeof MessageType>;

export type GetApiV3MetricsMessageExecutionRateRequest = {
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Subnet ID
   */
  subnet?: string | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsMessageExecutionRateFormat | undefined;
  /**
   * Message Type
   */
  messageType?: MessageType | undefined;
  /**
   * Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsMessageExecutionRateFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsMessageExecutionRateFormat> = z
    .nativeEnum(GetApiV3MetricsMessageExecutionRateFormat);

/** @internal */
export const GetApiV3MetricsMessageExecutionRateFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsMessageExecutionRateFormat> =
    GetApiV3MetricsMessageExecutionRateFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsMessageExecutionRateFormat$ {
  /** @deprecated use `GetApiV3MetricsMessageExecutionRateFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsMessageExecutionRateFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsMessageExecutionRateFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsMessageExecutionRateFormat$outboundSchema;
}

/** @internal */
export const MessageType$inboundSchema: z.ZodNativeEnum<typeof MessageType> = z
  .nativeEnum(MessageType);

/** @internal */
export const MessageType$outboundSchema: z.ZodNativeEnum<typeof MessageType> =
  MessageType$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace MessageType$ {
  /** @deprecated use `MessageType$inboundSchema` instead. */
  export const inboundSchema = MessageType$inboundSchema;
  /** @deprecated use `MessageType$outboundSchema` instead. */
  export const outboundSchema = MessageType$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsMessageExecutionRateRequest$inboundSchema:
  z.ZodType<GetApiV3MetricsMessageExecutionRateRequest, z.ZodTypeDef, unknown> =
    z.object({
      start: z.nullable(z.number()).default(null),
      subnet: z.nullable(z.string()).default(null),
      end: z.nullable(z.number()).default(null),
      format: GetApiV3MetricsMessageExecutionRateFormat$inboundSchema.default(
        "json",
      ),
      message_type: MessageType$inboundSchema.default("all"),
      step: z.number().int().default(7200),
    }).transform((v) => {
      return remap$(v, {
        "message_type": "messageType",
      });
    });

/** @internal */
export type GetApiV3MetricsMessageExecutionRateRequest$Outbound = {
  start: number | null;
  subnet: string | null;
  end: number | null;
  format: string;
  message_type: string;
  step: number;
};

/** @internal */
export const GetApiV3MetricsMessageExecutionRateRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsMessageExecutionRateRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsMessageExecutionRateRequest
  > = z.object({
    start: z.nullable(z.number()).default(null),
    subnet: z.nullable(z.string()).default(null),
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsMessageExecutionRateFormat$outboundSchema.default(
      "json",
    ),
    messageType: MessageType$outboundSchema.default("all"),
    step: z.number().int().default(7200),
  }).transform((v) => {
    return remap$(v, {
      messageType: "message_type",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsMessageExecutionRateRequest$ {
  /** @deprecated use `GetApiV3MetricsMessageExecutionRateRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsMessageExecutionRateRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsMessageExecutionRateRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsMessageExecutionRateRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsMessageExecutionRateRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsMessageExecutionRateRequest$Outbound;
}

export function getApiV3MetricsMessageExecutionRateRequestToJSON(
  getApiV3MetricsMessageExecutionRateRequest:
    GetApiV3MetricsMessageExecutionRateRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsMessageExecutionRateRequest$outboundSchema.parse(
      getApiV3MetricsMessageExecutionRateRequest,
    ),
  );
}

export function getApiV3MetricsMessageExecutionRateRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsMessageExecutionRateRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsMessageExecutionRateRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsMessageExecutionRateRequest' from JSON`,
  );
}
